import actionTypes from '../actionTypes'

const updateOnboardingProcess = data => {
  return {
    type: actionTypes.SET_ONBOARDING_PROCESS,
    payload: data,
  }
}

const updateCreateProject = data => {
  return {
    type: actionTypes.SET_CREATE_PROJECT,
    payload: data,
  }
}

const updateInstallTool = data => {
  return {
    type: actionTypes.SET_INSTALL_TOOL,
    payload: data,
  }
}

const updateCreateSecret = data => {
  return {
    type: actionTypes.SET_CREATE_SECRET,
    payload: data,
  }
}

const updateCreateAccessKey = data => {
  return {
    type: actionTypes.SET_CREATE_ACCESS_KEY,
    payload: data,
  }
}

const updateChangeProcessKey = data => {
  return {
    type: actionTypes.SET_CHANGE_PROCESS_KEY,
    payload: data,
  }
}

export default {
  updateOnboardingProcess,
  updateCreateProject,
  updateInstallTool,
  updateCreateSecret,
  updateCreateAccessKey,
  updateChangeProcessKey
}